import { render, staticRenderFns } from "./DrinksList.vue?vue&type=template&id=09721a7c&scoped=true&"
import script from "./DrinksList.vue?vue&type=script&lang=js&"
export * from "./DrinksList.vue?vue&type=script&lang=js&"
import style0 from "./DrinksList.vue?vue&type=style&index=0&id=09721a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09721a7c",
  null
  
)

export default component.exports